import React, { useState, useEffect } from 'react';
import { parseCookies, setCookie } from 'nookies';
import styles from './MobileBanner.module.sass';
import { IconSVG } from '../SpriteSVG';

const MobileBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  // Проверяем куки при загрузке компонента
  useEffect(() => {
    setIsMounted(true);
    const cookies = parseCookies();
    const bannerClosed = cookies.mobileBannerClosed;

    // Показываем баннер только если куки нет или она истекла
    if (!bannerClosed) {
      setIsVisible(true);
    }
  }, []);

  // Функция закрытия баннера
  const handleClose = () => {
    setIsVisible(false);
    // Устанавливаем куку на 3 дня
    setCookie(null, 'mobileBannerClosed', 'true', {
      maxAge: 3 * 24 * 60 * 60, // 3 дня в секундах
      path: '/',
    });
  };

  // Не рендерим до монтирования или если баннер скрыт
  if (!isMounted || !isVisible) {
    return null;
  }

  return (
    <div className={styles.promoBanner}>
      <img
        src={'/promotion/mobileBanner.png'}
        alt="Mobile App"
        className={styles.phone}
      />
      <div className={styles.content}>
        <h3>
          Скачивайте мобильное приложение — бронируйте круизы легко и быстро!
        </h3>
        <div style={{ display: 'flex', gap: '5px' }}>
          <a
            href={'https://apps.apple.com/ru/app/круиз-онлайн/id6751227682'}
            rel={'noreferrer'}
            target={'_blank'}
          >
            <img src={'/promotion/AppStore.png'} alt={'appstore'} />
          </a>
          <a
            href={
              'https://play.google.com/store/apps/details?id=online.kruiz.app'
            }
            target={'_blank'}
            rel={'noreferrer'}
          >
            <img src={'/promotion/googlePlay.png'} alt={'googlePlay'} />
          </a>
        </div>
      </div>
      <div className={styles.qr}>
        <div className={styles.qrInfo}>
          <img src={'/promotion/mobileArrow.png'} alt="Mobile Arrow" />
          <span className={styles.qrText}>Сканируй с мобильного</span>
        </div>
        <div className={styles.qrPlaceholder}>
          <IconSVG name={'common/qrMobile'} width={80} height={80} />
        </div>
      </div>
      <button
        className={styles.close}
        aria-label="Закрыть баннер"
        onClick={handleClose}
      >
        <img src={'/promotion/closeMobile.png'} alt="Mobile Close" />
      </button>
    </div>
  );
};

export default MobileBanner;
